import { render, staticRenderFns } from "./CounselRequestNew.vue?vue&type=template&id=7bc78f20&scoped=true"
import script from "./CounselRequestNew.vue?vue&type=script&lang=js"
export * from "./CounselRequestNew.vue?vue&type=script&lang=js"
import style0 from "./CounselRequestNew.vue?vue&type=style&index=0&id=7bc78f20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc78f20",
  null
  
)

export default component.exports